// @ts-nocheck

import { request } from '../context';
import type { ApiOptions } from '../context';
import type {
    BaseResponseListAgentGroupFoundResponse1,
    PostAgentGroupsBody,
    BaseResponseAgentGroupFoundResponse,
} from '../types';

/**
 * findAllTree
 *
 * @export
 * @tags agent-group-controller
 * @link [GET] /agentGroups
 */
export function getAgentGroups(): Promise<BaseResponseListAgentGroupFoundResponse1>;
export function getAgentGroups(
    options: ApiOptions<never, never>
): Promise<BaseResponseListAgentGroupFoundResponse1>;
export function getAgentGroups(
    options?: ApiOptions<never, never>
): Promise<BaseResponseListAgentGroupFoundResponse1> {
    return request<never, never, never>('/agentGroups', {
        ...options,
        method: 'get',
        __$requestCalleeName: 'getAgentGroups',
    });
}

/**
 * save
 *
 * @export
 * @tags agent-group-controller
 * @link [POST] /agentGroups
 */
export function postAgentGroups(
    data: PostAgentGroupsBody
): Promise<BaseResponseAgentGroupFoundResponse>;
export function postAgentGroups(
    data: PostAgentGroupsBody,
    options: ApiOptions<never, never>
): Promise<BaseResponseAgentGroupFoundResponse>;
export function postAgentGroups(
    data: PostAgentGroupsBody,
    options?: ApiOptions<never, never>
): Promise<BaseResponseAgentGroupFoundResponse> {
    return request<PostAgentGroupsBody, never, never>('/agentGroups', {
        ...options,
        data,
        method: 'post',
        __$requestCalleeName: 'postAgentGroups',
    });
}

export const meta = [
    { tags: ['agent-group-controller'], path: '/agentGroups', method: 'get' },
    { tags: ['agent-group-controller'], path: '/agentGroups', method: 'post' },
];
